module.exports = __webpack_public_path__ + "static/assets/acf8e02623682856899b55f10f66e212.svg";